import React from 'react'; 
import ReactDOM from 'react-dom/client';

import {police_3} from "./main_03_A.js";

export function Creator_A_title(id,anonymous,likes,title) {
const searchRegExp = /\s/g;
const replaceWith = '_';

var Action_button = React.createClass({
  displayName: "Action",
  getDefaultProps: function getDefaultProps() {
    return {
      id:id,
      number : 0
    };
  },  
  _handleKeyPress: function _handleKeyPress(e) {
//sambung besok la

if (this.props.number == 0) {
  var box = "post_id="+this.props.id;
 var xhttp = new XMLHttpRequest();
  
  xhttp.onreadystatechange = function() {
    if (this.readyState == 4 && this.status == 200) {
      //console.log(this.responseText);
      //container = this.responseText;

    }
  };

  xhttp.open("POST", "php/keyin02.php", true);
  xhttp.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
  xhttp.withCredentials = true;
  xhttp.send(box);

  //to get the int++
  document.getElementById(this.props.id).innerHTML = parseInt(document.getElementById(this.props.id).innerHTML) + 1;
this.props.number = 1;
  }
},
  render: function render() {
    return React.createElement(
      "button",
      { className: "Forlike", onClick: this._handleKeyPress },React.createElement("i",{className:"fas fa-thumbs-up"},React.createElement("p",{className:this.props.id,id:this.props.id},likes))
    );
  }
});

 var Creator = React.createClass({
  displayName: "Creator",

  getDefaultProps: function getDefaultProps() {
    return {
      name: anonymous,
      url: "url(./profile/assets/php/"+anonymous+"_front.png)"
    };
  },
  getfunction1: function getfunction1() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const group_id = urlParams.get('id')
    window.location.href = "./profile/profile.php?id="+group_id+"&name="+this.props.name;
  },
  render: function render() {
    return React.createElement(
      "div",
      { className: "creator" },
      React.createElement("img", {style: {backgroundImage: this.props.url}}),
      React.createElement(
        "div",
        {className:"Creator_container_title"},
        React.createElement("div",{className:"Creator_container_div_main"},
        React.createElement(
          "a",
          {href:"#",onClick:this.getfunction1},
          this.props.name.replace(searchRegExp, replaceWith)
        )),
          
        React.createElement("div", {className:"Button_tools_container_title"},
  //     React.createElement(Creator_tools_box_B,null),
  //      React.createElement(Creator_tools_box_A,null)
  React.createElement("h1",{},React.createElement("span",{},"Title:"),React.createElement("i",{className:"",style: {marginRight: "10px"}}),React.createElement("span",{style: {color: "orange"}}, title))
          )
      ));
  }
});

 return Creator;
}



export function Creator_A(id,anonymous,likes,title) {
var Action_button = React.createClass({
  displayName: "Action",
  getDefaultProps: function getDefaultProps() {
    return {
      id:id,
      number : 0
    };
  },  
  _handleKeyPress: function _handleKeyPress(e) {
//sambung besok la

if (this.props.number == 0) {
  var box = "post_id="+this.props.id;
 var xhttp = new XMLHttpRequest();
  
  xhttp.onreadystatechange = function() {
    if (this.readyState == 4 && this.status == 200) {
      //console.log(this.responseText);
      //container = this.responseText;

    }
  };

  xhttp.open("POST", "php/keyin02.php", true);
  xhttp.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
  xhttp.withCredentials = true;
  xhttp.send(box);

  //to get the int++
  document.getElementById(this.props.id).innerHTML = parseInt(document.getElementById(this.props.id).innerHTML) + 1;
this.props.number = 1;
  }
},
  render: function render() {
    return React.createElement(
      "button",
      { className: "Forlike", onClick: this._handleKeyPress },React.createElement("i",{className:"fas fa-thumbs-up"},React.createElement("p",{className:this.props.id,id:this.props.id},likes))
    );
  }
});

 var Creator_tools_box_A = React.createClass({

getDefaultProps: function getDefaultProps() {
    return {
      name: "anonymous"
    };
  },

  render: function render() {
    return React.createElement(
      "div",
      { className: "creator_box" },
      React.createElement(
        Action_button,
        {className: "Forlike"},
        "" 
      )
    );
  }

});

var Creator_tools_box_B = React.createClass({

getDefaultProps: function getDefaultProps() {
    return {
      name: "anonymous",
      tag_id: "comment_"+ id,
      tag_c_id: id + "_C2",
      police: "police_"+id,
      input_id: "input_"+id
    };
  },
f_function01: function f_function01() {
//to prevent people who are anynomous from key in without login
var i = id + "_M";

if(document.getElementById(i).style.display == "none"){
document.getElementById(i).style.display = "flow-root";
police_3(this.props.police,this.props.input_id);
}else
{document.getElementById(i).style.display = "none";};
},
  render: function render() {
    return React.createElement(
      "div",
      { className: "creator_box" },
      React.createElement(
        "button",
        {className: "ForMessage", href:"#"+this.props.tag_id},
    React.createElement("a",{href:"#"+this.props.tag_id,onClick:this.f_function01},React.createElement("i",{className:"fa fa-comment"},React.createElement("p",{id:this.props.tag_c_id},"0")))
      )
    );
  }


});



 var Creator = React.createClass({
  displayName: "Creator",

  getDefaultProps: function getDefaultProps() {
    return {
      name: anonymous,
      url: "url(./profile/assets/php/"+anonymous+"_front.png)"
    };
  },
  getfunction1: function getfunction1() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const group_id = urlParams.get('id')
    window.location.href = "./profile/profile.php?id="+group_id+"&name="+this.props.name;
  },
  render: function render() {
    return React.createElement(
      "div",
      { className: "creator_like_box" },
      React.createElement(
        "div",
        {className:"Creator_container"},
        React.createElement("div", {className:"Button_tools_container"},
       React.createElement(Creator_tools_box_B,null),
        React.createElement(Creator_tools_box_A,null)
  //React.createElement("h1",{},React.createElement("i",{className:"fa fa-question",style: {marginRight: "10px"}}),React.createElement("span",{}, "apa lagi bah ni")),
          )
      ));
  }
});

 return Creator;
}
